import React from "react";
import * as styles from "../FooterAppStyle.module.scss";
import {
  bottomText,
  textAboveDivider,
  textBelowDivider,
} from "../FooterApp.const";

export const FooterInformationsBlock = () => {
  return (
    <>
      <div className={styles.footer__text}>
        {textAboveDivider.map((text, index) => (
          <p key={`above-divider-${index}`} className={styles.footer__textItem}>
            <strong>{text.prefix}</strong> <span>{text.content}</span>
          </p>
        ))}
      </div>

      <div className={styles.footer__disclaimer}>
        {textBelowDivider.map((text, index) => (
          <p
            key={`below-divider-${index}`}
            className={styles.footer__disclaimerText}
          >
            <strong>{text.prefix}</strong> <span>{text.content}</span>
          </p>
        ))}
      </div>

      <div className={styles.footer__bottomText}>
        {bottomText.map((text, index) => (
          <p key={`bottomText-${index}`}>
            <strong>{text.prefix}</strong> <span>{text.content}</span>
          </p>
        ))}
      </div>
    </>
  );
};
